// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import xengEntity from './entities/xeng.json';
import xengMenu from '../pages/xeng/menu.json';
import xengFullForm from '../pages/xeng/forms/full.json';
import xengContextForm from '../pages/xeng/forms/context.json';
import xengMiniForm from '../pages/xeng/forms/mini.json';
import xengLookupForm from '../pages/xeng/forms/lookup.json';
import xengTableView from '../pages/xeng/views/table.json';
import xengStagesView from '../pages/xeng/views/stages.json';
import xengCardsView from '../pages/xeng/views/cards.json';
import xengInlineView from '../pages/xeng/views/inline.json';
import xengBacklogView from '../pages/xeng/views/backlog.json';
import xengSplitView from '../pages/xeng/views/split.json';
import xengCalendarView from '../pages/xeng/views/calendar.json';
import xengDashboardView from '../pages/xeng/views/dashboard.json';

/** Тип запису «Залучення» зі сторінками пакета: меню, форми та подання з pages/xeng/. */
export const xengDefinition: IRecordTypeDefinition = {
  ...xengEntity,
  views: assembleViewSet({
      table: xengTableView,
      stages: xengStagesView,
      cards: xengCardsView,
      inline: xengInlineView,
      backlog: xengBacklogView,
      split: xengSplitView,
      calendar: xengCalendarView,
      dashboard: xengDashboardView,
  }),
  form: xengFullForm,
  forms: { full: xengFullForm, context: xengContextForm, mini: xengMiniForm, lookup: xengLookupForm },
  menu: xengMenu,
} as IRecordTypeDefinition;
